import axios from 'axios'
// import Api from '@/services/Api'
/* eslint-disable */
export default {
    index() {
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/Racer/GetAll`)
    },
    disIndex() {
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/agent/getAllDisabled`)
    }
    ,
    post(body) {
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/Race/RequestRace`, JSON.stringify(body), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },
    finIndex(c, o) {
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/Race/GetFinishedRace`, null, {
            params: {
                count: c,
                offset: o
            }
        })
    },
    runIndex(c, o) {
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/Race/GetRaceRunning`, null, {
            params: {
                count: c,
                offset: o
            }
        })
    },
    nextIndex(c, o) {
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/Race/GetFutureRace`, null, {
            params: {
                count: c,
                offset: o
            }
        })
    },

    // ,
    // put(visitrequest) {
    //     return Api().put('', )
    // },
    delete(userid) {
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/agent/delete`, null, {
            params: {
                id: userid
            }
        })
    }
}